export const mainRouting = [
  {
    routeName: 'card',
    icon: 'mdi-card-account-details-outline',
    title: 'Karta',
    text: 'Twoja elektroniczna karta mieszkańca'
  },
  {
    routeName: 'partners',
    icon: 'mdi-account-multiple',
    title: 'Partnerzy',
    text: 'Zobacz listę firm współpracujących z serwisem Karta Miejska'
  },
  {
    routeName: 'events',
    icon: 'mdi-cards-outline',
    title: 'Usługi',
    text: 'Wszystkie aktywne i zbliżające się oferty oraz promocje'
  },
  {
    routeName: 'history',
    icon: 'mdi-history',
    title: 'Historia',
    text: 'Historia twojej aktywności'
  }
];
